type Props = {
  disabled: boolean;
  label: string;
  clickedLabel?: string;
};

const SubmitButton: React.FC<Props> = ({
  disabled,
  label,
  clickedLabel = "Submitting...",
}) => (
  <button
    type="submit"
    className="h-8 w-auto self-start rounded-md bg-blue hover:bg-blue200 disabled:bg-blue500 px-4 text-lg uppercase text-white mb-[-10px]"
    disabled={disabled}
  >
    {disabled ? clickedLabel : label}
  </button>
);

export default SubmitButton;
